import common from './pt/common';
import auth from './pt/auth';
import navigation from './pt/navigation';
import profile from './pt/profile';
import integrations from './pt/integrations';
import agents from './pt/agents';
import skills from './pt/skills';
import jobs from './pt/jobs';
import dashboards from './pt/dashboards';
import settings from './pt/settings';
import { subscription } from './pt/subscription';
import dataSources from './pt/dataSources';
import playground from './pt/playground';
import knowledge from './pt/knowledge';
import memory from './pt/memory';
import learnings from './pt/learnings';
import workflow from './pt/workflow';
import register from './pt/register';
import resetPassword from './pt/resetPassword';
import recoverPassword from './pt/recoverPassword';
import logs from './pt/logs';
import users from './pt/users';
import installation from './pt/installation';
import dynamicParameterFields from './pt/ui/dynamic-parameter-fields';
import tour from './pt/tour';
import workspaces from './pt/workspaces';
import communicator from './pt/communicator';
import assistant from './pt/assistant';
import products from './pt/products';
import facets from './pt/facets';
import errors from './pt/errors';
import notifications from './pt/notifications';

const translations = {
  common,
  errors,
  auth,
  navigation,
  profile,
  integrations,
  agents,
  skills,
  jobs,
  dashboards,
  settings,
  subscription,
  dataSources,
  playground,
  knowledge,
  memory,
  learnings,
  workflow,
  register,
  resetPassword,
  recoverPassword,
  logs,
  users,
  installation,
  dynamicParameterFields,
  tour,
  workspaces,
  communicator,
  assistant,
  products,
  facets,
  notifications,
} as const;

export default translations;
